module.exports = __webpack_public_path__ + "static/media/strata-financial.86c41903.png";